import { RegionShared } from "@1games-ru/region-shared";
import { useQuery } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider";
import { setPlayerInfo } from "@/domains/player/slice";

export default function useGetPlayer() {
  const [isPending, setIsPending] = useState(false);
  const dispatch = useAppDispatch();

  const getPlayer = useCallback(async () => {
    setIsPending(true);
    const response = await RpcMpProvider.getInstance().callClient<
      typeof RegionShared.Client.Requests.GetPlayerRequest,
      typeof RegionShared.Client.Responses.GetPlayerResponse
    >(RegionShared.Client.Events.Player.GetPlayer, {});
    if (response instanceof RpcMpProviderSuccessResponse) {
      dispatch(setPlayerInfo(response.data));
    }
    setIsPending(false);
  }, []);

  return { isPending, getPlayer };
}

export const QUERY_KEY_PLAYER = "player";

export function usePlayerQuery() {
  return useQuery({
    queryKey: [QUERY_KEY_PLAYER],
    queryFn: async () => {
      const response = await RpcMpProvider.getInstance().callClient<
        typeof RegionShared.Client.Requests.GetPlayerRequest,
        typeof RegionShared.Client.Responses.GetPlayerResponse
      >(RegionShared.Client.Events.Player.GetPlayer, {});

      if (response instanceof RpcMpProviderSuccessResponse) {
        if (response.data.character === null) {
          throw new Error("Character not found");
        }

        return response.data;
      }

      throw new Error(response.message);
    },
    retry: 5,
  });
}
